import { jsx as s, jsxs as p } from "react/jsx-runtime";
import { useFoundation as y, createComponent as S, useClassNames as b, Tag as h } from "@rmwc/base";
import { MDCCircularProgressFoundation as k } from "@material/circular-progress";
import { useState as w, useEffect as v } from "react";
const M = {
  xsmall: 24,
  small: 24,
  medium: 32,
  large: 48,
  xlarge: 48
}, f = {
  24: 12,
  32: 16,
  48: 24
}, R = {
  24: 8.75,
  32: 12.5,
  48: 18
}, T = {
  24: 54.978,
  32: 78.54,
  48: 113.097
}, E = {
  24: 27.489,
  32: 39.27,
  48: 56.549
}, W = {
  24: 2.5,
  32: 3,
  48: 4
}, F = {
  24: 2,
  32: 2.4,
  48: 3.2
}, O = (o) => {
  const { foundation: i, ...u } = y({
    props: o,
    elements: { rootEl: !0, determinateCircleEl: !0 },
    foundation: ({ rootEl: t, determinateCircleEl: n }) => new k({
      addClass: (r) => t.addClass(r),
      getDeterminateCircleAttribute: (r) => {
        var l;
        return (l = n.ref) == null ? void 0 : l.getAttribute(r);
      },
      hasClass: (r) => t.hasClass(r),
      removeClass: (r) => t.removeClass(r),
      removeAttribute: (r) => t.removeProp(r),
      setAttribute: (r, l) => {
        t.setProp(r, l);
      },
      setDeterminateCircleAttribute: (r, l) => {
        var m;
        return (m = n.ref) == null ? void 0 : m.setAttribute(r, l);
      }
    })
  }), [d, a] = w(
    void 0
  );
  return v(() => {
    i.setProgress(o.progress || 0);
    const t = o.progress !== void 0;
    t !== d && (i.setDeterminate(t), a(t));
  }, [o.progress, d, i]), v(() => {
    o.closed ? i.close() : i.open();
  }, [o.closed, i]), { foundation: i, ...u };
}, j = S(
  function(i, u) {
    const {
      closed: d,
      size: a = "small",
      max: t = 1,
      min: n = 0,
      progress: r,
      label: l,
      ...m
    } = i, { rootEl: x, determinateCircleEl: A } = O(i), C = b(i, [
      "mdc-circular-progress",
      `rmwc-circular-progress--${a}`,
      {
        "mdc-circular-progress--closed": d
      }
    ]), P = r !== void 0, _ = typeof a == "number", e = M[_ ? "medium" : a], D = _ ? {
      ...m.style,
      fontSize: `${a}px`,
      width: `${a}px`,
      height: `${a}px`
    } : { ...m.style }, N = (c) => c < n ? 0 : c > t ? 1 : (c - n) / (t - n), $ = (c) => r !== void 0 ? {
      strokeDasharray: `${2 * Math.PI * (c / 2.4) * N(r)}, 666.66%`,
      width: `${c}px`,
      height: `${c}px`
    } : void 0, g = (c) => ({
      cx: f[c],
      cy: f[c],
      r: R[c],
      strokeDasharray: T[c],
      strokeDashoffset: E[c],
      strokeWidth: W[c]
    });
    return /* @__PURE__ */ s(
      h,
      {
        "aria-valuenow": r,
        "aria-valuemin": n,
        "aria-valuemax": t,
        "aria-label": l,
        ...m,
        style: D,
        className: C,
        element: x,
        ref: u,
        role: "progressbar",
        children: P ? /* @__PURE__ */ s("div", { className: "mdc-circular-progress__determinate-container", children: /* @__PURE__ */ p(
          "svg",
          {
            className: "mdc-circular-progress__determinate-circle-graphic",
            viewBox: `0 0 ${e} ${e}`,
            children: [
              /* @__PURE__ */ s(
                "circle",
                {
                  className: "mdc-circular-progress__determinate-track",
                  cx: e / 2,
                  cy: e / 2,
                  r: e / 2.4,
                  strokeWidth: "4"
                }
              ),
              /* @__PURE__ */ s(
                h,
                {
                  tag: "circle",
                  className: "mdc-circular-progress__determinate-circle",
                  style: $(e),
                  cx: e / 2,
                  cy: e / 2,
                  r: e / 2.4,
                  element: A,
                  strokeDashoffset: "113.097",
                  strokeWidth: "4"
                }
              )
            ]
          }
        ) }) : /* @__PURE__ */ s("div", { className: "mdc-circular-progress__indeterminate-container", children: /* @__PURE__ */ p("div", { className: "mdc-circular-progress__spinner-layer", children: [
          /* @__PURE__ */ s("div", { className: "mdc-circular-progress__circle-clipper mdc-circular-progress__circle-left", children: /* @__PURE__ */ s(
            "svg",
            {
              className: "mdc-circular-progress__indeterminate-circle-graphic",
              viewBox: `0 0 ${e} ${e}`,
              children: /* @__PURE__ */ s("circle", { ...g(e) })
            }
          ) }),
          /* @__PURE__ */ s("div", { className: "mdc-circular-progress__gap-patch", children: /* @__PURE__ */ s(
            "svg",
            {
              className: "mdc-circular-progress__indeterminate-circle-graphic",
              viewBox: `0 0 ${e} ${e}`,
              children: /* @__PURE__ */ s(
                "circle",
                {
                  ...g(e),
                  strokeWidth: F[e]
                }
              )
            }
          ) }),
          /* @__PURE__ */ s("div", { className: "mdc-circular-progress__circle-clipper mdc-circular-progress__circle-right", children: /* @__PURE__ */ s(
            "svg",
            {
              className: "mdc-circular-progress__indeterminate-circle-graphic",
              viewBox: `0 0 ${e} ${e}`,
              children: /* @__PURE__ */ s("circle", { ...g(e) })
            }
          ) })
        ] }) })
      }
    );
  }
);
export {
  j as CircularProgress
};
